// extracted by mini-css-extract-plugin
export default {"header-container":"Header_header-container__JCO41","header-link":"Header_header-link__QDq++","name":"Header_name__Jdp6n","secondary":"Header_secondary__bxU5i"};